import React from "react";
import { Switch, Route } from "react-router-dom";
import Overview from "./Overview";
import Batch from "./Batch";
import Guess from "./Guess";
import GuessAlt from "./GuessAlt";
import DonorIncentives from "./DonorIncentives";
import CharityIncentives from "./CharityIncentives";
import ToolsResources from "./ToolsResources";
import Participating from "./Participating";
import Payment from "./Payment";
import Donate from "./Donate";
import Receipt from "./Receipt";
import Charity from "./Charity";
/* import Report from "./Report"; no longer used */
/* import CharityRegClosed from "./CharityRegClosed"; */
import CharityRegHome from "./CharityRegHome";
import CharityRegReturning from "./CharityRegReturning";
import CharityRegInfo from "./CharityRegInfo";
import CharityRegContact from "./CharityRegContact";
import CharityRegDocuments from "./CharityRegDocuments";
import CharityRegPledge from "./CharityRegPledge";
import CharityRegPromote from "./CharityRegPromote";
import CharityRegDeandi from "./CharityRegDeandi";
import CharityRegSubmit from "./CharityRegSubmit";
import CharityRegSubmitted from "./CharityRegSubmitted";

import FriendsDonate from "./FriendsDonate";
import FriendsSignup from "./Friends/Signup";
import FriendsSignin from "./Friends/Signin";
import FriendsDashSigningin from "./Friends/Signingin";
import FriendsDash from "./Friends/Dash";

import Rsvp from "./Rsvp";

const App = () => {
	return (
		<Switch>
			<Route exact path="/rsvp" component={Rsvp} />

			{/* comment these when charity registration is closed */}
			<Route exact path="/registration/r" component={CharityRegReturning} />
			<Route exact path="/registration" component={CharityRegHome} />
			<Route
				exact
				path="/registration/submitted"
				component={CharityRegSubmitted}
			/>
			<Route exact path="/registration/submit" component={CharityRegSubmit} />
			<Route exact path="/registration/deandi" component={CharityRegDeandi} />
			<Route exact path="/registration/promote" component={CharityRegPromote} />
			<Route exact path="/registration/pledge" component={CharityRegPledge} />
			<Route
				exact
				path="/registration/documents"
				component={CharityRegDocuments}
			/>
			<Route exact path="/registration/contact" component={CharityRegContact} />
			<Route exact path="/registration/info" component={CharityRegInfo} />

			{/* uncomment these when charity registration is closed 
			<Route path="/registration" component={CharityRegClosed} />
			<Route path="/registration/r" component={CharityRegClosed} />
			*/}

			<Route exact path="/friends/donate" component={FriendsDonate} />
			<Route exact path="/friends/signup" component={FriendsSignup} />
			<Route exact path="/friends/signin" component={FriendsSignin} />
			<Route exact path="/friends/dash/:str" component={FriendsDashSigningin} />
			<Route exact path="/friends/dash" component={FriendsDash} />

			{/*<Route exact path="/report" component={Report} />*/}
			<Route exact path="/charity" component={Charity} />
			<Route exact path="/receipt" component={Receipt} />
			<Route exact path="/donate" component={Donate} />
			<Route exact path="/payment" component={Payment} />
			<Route exact path="/participating-charities" component={Participating} />
			<Route exact path="/tools-resources" component={ToolsResources} />
			<Route exact path="/charity-incentives" component={CharityIncentives} />
			<Route exact path="/donor-incentives" component={DonorIncentives} />
			<Route exact path="/guess" component={Guess} />
			<Route exact path="/guessalt" component={GuessAlt} />
			<Route exact path="/batch" component={Batch} />
			<Route exact path="/" component={Overview} />
		</Switch>
	);
};

export default App;
